import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Table, Button, Spinner } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import Loading from "../components/Loading";
import Message from "../components/Message";
import {
  listOrders,
  payOrder,
  deliverOrder,
} from "../redux/actions/orderActions";

const OrderListScreen = () => {
  const dispatch = useDispatch();

  const ordersList = useSelector((state) => state.orderListOrder);
  const { orders, loading, error } = ordersList;

  const [loadingPayOrderId, setLoadingPayOrderId] = useState(null);
  const [loadingDeliverOrderId, setLoadingDeliverOrderId] = useState(null);
  const [errorPay, setErrorPay] = useState(null);
  const [errorDeliver, setErrorDeliver] = useState(null);

  useEffect(() => {
    dispatch(listOrders());
  }, [dispatch]);

  const handleTogglePaid = async (order) => {
    if (order.isPaid) {
      alert("Order is already paid and cannot be marked unpaid.");
      return;
    }

    const confirm = window.confirm(`Mark order ${order._id} as paid?`);
    if (!confirm) return;

    try {
      setLoadingPayOrderId(order._id);
      setErrorPay(null);

      // Send minimal dummy payment result as admin update
      await dispatch(
        payOrder(order._id, {
          id: "admin-payment",
          status: "Paid",
          update_time: new Date().toISOString(),
          payer: { email_address: "dhvanit03@gmail.com" },
        })
      );

      dispatch(listOrders());
    } catch (err) {
      setErrorPay(err.message || "Failed to mark order as paid. Try again.");
    } finally {
      setLoadingPayOrderId(null);
    }
  };

  const handleToggleDelivered = async (order) => {
    if (!order.isPaid) {
      alert("Order must be marked as paid before it can be marked as delivered.");
      return;
    }

    if (order.isDelivered) {
      alert(
        "Order is already marked as delivered and this status cannot be changed."
      );
      return;
    }

    const confirm = window.confirm(`Mark order ${order._id} as delivered?`);
    if (!confirm) return;

    try {
      setLoadingDeliverOrderId(order._id);
      setErrorDeliver(null);
      await dispatch(deliverOrder(order._id));
      dispatch(listOrders());
    } catch (err) {
      setErrorDeliver(
        err.message || "Failed to mark order as delivered. Try again."
      );
    } finally {
      setLoadingDeliverOrderId(null);
    }
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : error ? (
        <Message variant="danger">{error}</Message>
      ) : (
        <Row>
          <h3>Orders List</h3>
          <Col>
            {errorPay && <Message variant="danger">{errorPay}</Message>}
            {errorDeliver && <Message variant="danger">{errorDeliver}</Message>}
            <Table striped rounded="true" hover className="table-sm">
              <thead>
                <tr>
                  <td>ID</td>
                  <td>User</td>
                  <td>Contact</td>
                  <td>Date</td>
                  <td>Total</td>
                  <td>Paid</td>
                  <td>Transaction ID</td>
                  <td>Delivered</td>
                  <td></td>
                </tr>
              </thead>
              <tbody>
                {orders.map((order, index) => (
                  <tr key={index}>
                    <td>{order._id}</td>
                    <td>{order.user ? order.user.name : "Unknown User"}</td>
                    <td>{order.user && order.user.contactNumber ? order.user.contactNumber : "N/A"}</td>
                    <td>{order.createdAt.substring(0, 10)}</td>
                    <td>₹{order.totalPrice}</td>
                    <td>
                      <Button
                        size="sm"
                        variant={order.isPaid ? "success" : "danger"}
                        onClick={() => handleTogglePaid(order)}
                        disabled={loadingPayOrderId === order._id}
                      >
                        {loadingPayOrderId === order._id ? (
                          <Spinner animation="border" size="sm" />
                        ) : order.isPaid ? (
                          order.paidAt.substring(0, 10)
                        ) : (
                          <i className="fas fa-times" />
                        )}
                      </Button>
                    </td>
                    <td>{order.transactionId || "N/A"}</td>
                    <td>
                      <Button
                        size="sm"
                        variant={order.isDelivered ? "success" : "danger"}
                        onClick={() => handleToggleDelivered(order)}
                        disabled={loadingDeliverOrderId === order._id}
                      >
                        {loadingDeliverOrderId === order._id ? (
                          <Spinner animation="border" size="sm" />
                        ) : order.isDelivered ? (
                          order.deliveredAt.substring(0, 10)
                        ) : (
                          <i className="fas fa-times" />
                        )}
                      </Button>
                    </td>
                    <td>
                      <LinkContainer className="ml-1" to={`/order/${order._id}`}>
                        <Button className="btn btn-sm" variant="primary">
                          Details
                        </Button>
                      </LinkContainer>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      )}
    </>
  );
};

export default OrderListScreen;
